export class UserProfile {
  userName: string;
  email: string;
  dbIdentity: string;
  roles: Array<string>;
  pmaUserDetailsId: string;
  databaseDisplayName: string;
  daysLeftBeforePasswordExpires: number;
  authenticatedViaDesktopApp: boolean;
  pmaPermissions: string[];
  previousLoginTime: Date;
}
